export const getCurrency = state => state.services.currency;
export const getDrop = state => state.services.drop;
export const getService = state => state.services.service;
export const getDropUnits = state => state.services.drop_units_m2;
export const getUnit  = state => state.services.unit


export const getMaterialPriceModal = state => state.modal.materialProductPrice;
export const getProductPriceForm = state => state.services.productPriceForm;